module.exports = __webpack_public_path__ + "img/ic-support-square.fc479678.webp";